export default __webpack_public_path__ + "static/media/weatherBackground.8d2bb2d8.png";